<script setup>
import NewsArticleForm from '@frontJs/components/forms/projectManagement/apikom/NewsArticleForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { newsArticle, newsThemes, tenantTypes } = defineProps({
    newsArticle: {
        type: [Object, null],
        required: false,
    },
    newsThemes: {
        type: Array,
        required: true,
    },
    tenantTypes: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="newsArticle">
            Mettre à jour l'actualité #{{ newsArticle.id }} - Gestion de projet
            - Datakepler
        </title>

        <title v-else>
            Créer une actualité - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="newsArticle">
        Gestion de projet - Mettre à jour l'actualité #{{ newsArticle.id }}
    </PageTitle>

    <PageTitle v-else> Gestion de projet - Créer une actualité </PageTitle>

    <NewsArticleForm
        :news-article="newsArticle"
        :news-themes="newsThemes"
        :tenant-types="tenantTypes"
    />
</template>
